import { render, staticRenderFns } from "./LatestProducts.vue?vue&type=template&id=2b1fd324&scoped=true&"
import script from "./LatestProducts.vue?vue&type=script&lang=js&"
export * from "./LatestProducts.vue?vue&type=script&lang=js&"
import style0 from "./LatestProducts.vue?vue&type=style&index=0&id=2b1fd324&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1fd324",
  null
  
)

/* custom blocks */
import block0 from "./LatestProducts.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports